import React from 'react';
import { Box } from '@mui/material';
import logo from '../assets/img/logo.svg';
import './Header.css';

export const Header = () => {
    return (
        <Box className="header" display="flex" alignItems="center" padding={2}>
            <img src={logo} alt="logo" />
        </Box>
    );
};
